export default "__VITE_PUBLIC_ASSET__05d8dc63__"